import { Module, Mutation, VuexModule } from "vuex-module-decorators";

import Store from "../store";
import { Translation } from "@/interfaces/Translation";

@Module({
  dynamic: true,
  name: "appTextModule",
  namespaced: true,
  store: Store
})
export default class AppTextModule extends VuexModule {
  private appTextState: Translation[] = [];

  // get functions are converted to store getters
  // return a function from getter to use it with parameters
  // https://github.com/championswimmer/vuex-module-decorators/issues/40
  get appTextByKey() {
    return (key: string) => {
      const result = this.appTextState.find(appText => appText.key === key);
      return result != undefined ? result.value : key;
    };
  }

  @Mutation
  public set(thematics: Translation[]) {
    this.appTextState = thematics;
  }
}
